import _ from 'lodash';

import * as types from './types';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  fetchingSiteGroupWithSitesAndWHLoading: false,
  siteGroupWithSitesAndWHData: [],
  fetchingSiteGroupWithSitesAndWHLoadingError: null,
  fetchingSiteGroupWHLoading: false,
  siteGroupWHData: [],
  fetchingSiteGroupWHLoadingError: null,
  submittingOrderPreferenceLoading: false,
  submittingOrderPreferenceLoadingError: null,
  submittingOrderPreferenceData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING:
      return {
        ...state,
        fetchingSiteGroupWithSitesAndWHLoading: action.payload,
      };
    case types.SITEGROUP_WITH_SITES_AND_WAREHOUSE_DATA:
      return {
        ...state,
        siteGroupWithSitesAndWHData: action.payload,
      };
    case types.FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING_ERROR:
      const fetchingSiteGroupWithSitesAndWHLoadingError =
        action.payload.response;
      if (
        _.has(fetchingSiteGroupWithSitesAndWHLoadingError, 'data.Errors') &&
        fetchingSiteGroupWithSitesAndWHLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchingSiteGroupWithSitesAndWHLoadingError:
            fetchingSiteGroupWithSitesAndWHLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchingSiteGroupWithSitesAndWHLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching category list. Please try again.',
        },
      };
    case types.FETCH_SITE_GROUP_WAREHOUSE_LOADING:
      return {
        ...state,
        fetchingSiteGroupWHLoading: action.payload,
      };
    case types.SITE_GROUP_WAREHOUSE_DATA:
      return {
        ...state,
        siteGroupWHData: action.payload,
      };
    case types.FETCH_SITE_GROUP_WAREHOUSE_LOADING_ERROR:
      const fetchingSiteGroupWHLoadingError = action.payload.response;
      if (
        _.has(fetchingSiteGroupWHLoadingError, 'data.Errors') &&
        fetchingSiteGroupWHLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchingSiteGroupWHLoadingError:
            fetchingSiteGroupWHLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchingSiteGroupWHLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching category list. Please try again.',
        },
      };
    case types.CLEAR_ERROR_MESSAGES:
      return {
        ...state,
        fetchingSiteGroupWithSitesAndWHLoadingError: null,
        fetchingSiteGroupWHLoadingError: null,
        submittingOrderPreferenceData: null,
      };
    case types.SUBMITTING_ORDER_PREFERENCE_LOADING:
      return {
        ...state,
        submittingOrderPreferenceLoading: action.payload,
      };
    case types.SUBMITTING_ORDER_PREFERENCE_LOADING_ERROR:
      const submittingOrderPreferenceLoadingError = action.payload.response;
      if (
        _.has(submittingOrderPreferenceLoadingError, 'data.Errors') &&
        submittingOrderPreferenceLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          submittingOrderPreferenceLoadingError:
            submittingOrderPreferenceLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        submittingOrderPreferenceLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching category list. Please try again.',
        },
      };
    case types.SUBMITTED_ORDER_PREFERENCE_DATA:
      return {
        ...state,
        submittingOrderPreferenceData: action.payload.data,
      };
    case types.CLEAR_SUBMIT_ERROR:
      return {
        ...state,
        submittingOrderPreferenceLoadingError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignorderpreference/reducer.js